import { render, staticRenderFns } from "./ReturnView.vue?vue&type=template&id=63811fab&scoped=true&"
import script from "./ReturnView.vue?vue&type=script&lang=js&"
export * from "./ReturnView.vue?vue&type=script&lang=js&"
import style0 from "./ReturnView.vue?vue&type=style&index=0&id=63811fab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63811fab",
  null
  
)

export default component.exports